(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["custom-blog-center"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('toumei-blog-center')) {
    customElements.define('toumei-blog-center', class extends HTMLElement {
      connectedCallback() {
        if (this.initialized) return;
        this.initialized = true;
        this.tabs = Array.from(this.querySelectorAll('[data-center-tab]'));
        this.panels = Array.from(this.querySelectorAll('[data-center-panel]'));
        this.activate(this.tabs.find(tab => tab.getAttribute('aria-selected') === 'true') || this.tabs[0]);
        this.addEventListener('click', event => {
          const tab = event.target.closest('[data-center-tab]');
          if (!tab || !this.tabs.includes(tab) || event.button !== 0 || event.ctrlKey || event.metaKey || event.shiftKey || event.altKey) return;
          event.preventDefault();
          this.activate(tab);
        });
        this.addEventListener('keydown', event => {
          const index = this.tabs.indexOf(event.target);
          if (index < 0) return;
          if (event.key === ' ') {
            event.preventDefault();
            this.activate(this.tabs[index]);
            return;
          }
          let next;
          if (event.key === 'ArrowRight') next = (index + 1) % this.tabs.length;
          if (event.key === 'ArrowLeft') next = (index + this.tabs.length - 1) % this.tabs.length;
          if (event.key === 'Home') next = 0;
          if (event.key === 'End') next = this.tabs.length - 1;
          if (next === undefined) return;
          event.preventDefault();
          this.activate(this.tabs[next]);
          this.tabs[next].focus();
        });
      }
      activate(selectedTab) {
        const key = selectedTab.dataset.centerTab;
        this.tabs.forEach(tab => {
          const active = tab === selectedTab;
          tab.setAttribute('aria-selected', String(active));
          tab.tabIndex = active ? 0 : -1;
        });
        this.panels.forEach(panel => { panel.hidden = panel.dataset.centerPanel !== key; });
      }
    });
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-product"]) return;
  try {
    
  if (!customElements.get('toumei-product')) {
    customElements.define('toumei-product', class extends HTMLElement {
      connectedCallback() {
        this.onReady = () => this.initialize();
        if (document.readyState === 'loading') {
          document.addEventListener('DOMContentLoaded', this.onReady, { once: true });
        } else {
          this.initialize();
        }
      }

      disconnectedCallback() {
        document.removeEventListener('DOMContentLoaded', this.onReady);
        this.controller?.abort();
        this.initialized = false;
      }

      initialize() {
        if (this.initialized || !this.isConnected) return;
        const data = this.querySelector('[data-product-variants]');
        if (!data) return;
        this.data = JSON.parse(data.textContent);
        this.form = this.querySelector('form[id="' + this.dataset.formId + '"]');
        this.options = [...this.querySelectorAll('[data-option-index]')];
        this.controller = new AbortController();
        const listeners = { signal: this.controller.signal };
        this.addEventListener('change', (event) => {
          if (!event.target.matches('.variant-options input[type="radio"]')) return;
          const selected = this.options.map((option) => option.querySelector('input:checked')?.value);
          const variant = this.data.variants.find((item) => item.options.every((value, index) => selected[index] === value));
          this.applyVariant(variant, true);
        }, listeners);
        this.addEventListener('click', (event) => {
          const thumbnail = event.target.closest('[data-media-target]');
          if (thumbnail && this.contains(thumbnail)) this.showMedia(thumbnail.dataset.mediaTarget);
        }, listeners);
        const canHover = window.matchMedia('(hover: hover) and (pointer: fine)');
        this.querySelectorAll('[data-media-target][data-media-type="image"]').forEach((thumbnail) => {
          thumbnail.addEventListener('pointerenter', (event) => {
            if (event.pointerType === 'mouse' && canHover.matches && thumbnail.getAttribute('aria-pressed') !== 'true') {
              this.showMedia(thumbnail.dataset.mediaTarget);
            }
          }, listeners);
        });
        window.addEventListener('popstate', () => this.restoreVariant(false), listeners);
        if (this.form) {
          this.form.addEventListener('submit', (event) => {
            if (!this.currentVariant?.available) {
              event.preventDefault();
              event.stopImmediatePropagation();
            }
          }, { capture: true, signal: this.controller.signal });
        }
        this.initialized = true;
        this.restoreVariant(true);
        const activeMedia = this.querySelector('.media-item.active');
        if (activeMedia) this.showMedia(activeMedia.dataset.mediaId);
      }

      restoreVariant(initial) {
        const id = new URL(window.location.href).searchParams.get('variant');
        const variant = this.data.variants.find((item) => String(item.id) === id)
          || this.data.variants.find((item) => item.id === (initial ? this.data.initialId : this.data.defaultId))
          || this.data.variants[0];
        this.applyVariant(variant, false);
      }

      applyVariant(variant, updateUrl) {
        this.currentVariant = variant;
        if (variant) {
          this.options.forEach((option, index) => {
            option.querySelectorAll('input').forEach((input) => { input.checked = input.value === variant.options[index]; });
          });
        }
        const selected = this.options.map((option) => option.querySelector('input:checked')?.value);
        this.options.forEach((option, index) => {
          option.querySelectorAll('input').forEach((input) => {
            const available = this.data.variants.some((item) => item.available && item.options.every((value, position) => value === (position === index ? input.value : selected[position])));
            input.dataset.unavailable = String(!available);
          });
        });
        const price = this.querySelector('.price-current');
        const compare = this.querySelector('.price-compare');
        if (price) price.innerHTML = variant ? variant.priceHtml : this.data.unavailable;
        if (compare) {
          compare.hidden = !variant || !(variant.compareAtPrice > variant.price);
          compare.innerHTML = variant ? variant.compareHtml : '';
        }
        if (this.form) {
          const input = this.form.querySelector('[name="id"]');
          if (input) {
            input.value = variant ? String(variant.id) : '';
            input.disabled = !variant;
            input.dispatchEvent(new Event('change', { bubbles: true }));
          }
          const submit = this.form.querySelector('[name="add"]');
          if (submit) {
            submit.disabled = !variant?.available;
            submit.setAttribute('aria-disabled', String(!variant?.available || submit.classList.contains('loading')));
            const label = submit.querySelector('.btn-label');
            if (label) label.textContent = variant ? variant.buttonLabel : this.data.unavailable;
          }
          const checkout = this.form.querySelector('.btn-checkout-dynamic');
          if (checkout) checkout.hidden = !variant?.available;
          const quantity = this.form.querySelector('[name="quantity"]');
          if (quantity && variant) {
            const rule = variant.quantityRule || {};
            const minimum = Number(rule.min) || 1;
            const step = Number(rule.increment) || 1;
            quantity.min = String(minimum);
            quantity.step = String(step);
            if (rule.max != null) quantity.max = String(rule.max);
            else quantity.removeAttribute('max');
            let value = Math.max(minimum, Number(quantity.value) || minimum);
            value = minimum + Math.ceil((value - minimum) / step) * step;
            if (rule.max != null) value = Math.min(value, Number(rule.max));
            quantity.value = String(value);
          }
        }
        if (variant?.mediaId) this.showMedia(String(variant.mediaId));
        if (updateUrl && variant) {
          const url = new URL(window.location.href);
          if (url.searchParams.get('variant') !== String(variant.id)) {
            url.searchParams.set('variant', String(variant.id));
            window.history.pushState(window.history.state, '', url);
          }
        }
      }

      showMedia(id) {
        const active = [...this.querySelectorAll('.media-item')].find((item) => item.dataset.mediaId === id);
        if (!active) return;
        this.querySelectorAll('.media-item').forEach((item) => {
          const selected = item === active;
          item.hidden = !selected;
          item.classList.toggle('active', selected);
          if (!selected) {
            item.querySelectorAll('video').forEach((video) => video.pause());
            item.querySelectorAll('iframe').forEach((iframe) => iframe.remove());
          }
        });
        const template = active.querySelector('template[data-media-content]');
        if (template && !active.querySelector('video, iframe, model-viewer')) active.append(template.content.cloneNode(true));
        this.querySelectorAll('[data-media-target]').forEach((thumbnail) => {
          const selected = thumbnail.dataset.mediaTarget === id;
          thumbnail.classList.toggle('active', selected);
          thumbnail.setAttribute('aria-pressed', String(selected));
        });
      }
    });
  }

  } catch(e) { console.error(e); }
})();
})();
